import Vue from "vue";
import { ValidationProvider, ValidationObserver } from "./rules";

Vue.component("validation-provider", ValidationProvider);
Vue.component("validation-observer", ValidationObserver);
